
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9263"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9263"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $2sqaL = parcelRequire("2sqaL");
const $95a21c9e1364b2b4$var$SB_URL = "https://thapqeodawxffacnljij.supabase.co";
const $95a21c9e1364b2b4$var$SB_KEY = "sb_publishable_TZQOtUq1RwjDGBpWDb92UA_KZwAOHUS";
const $95a21c9e1364b2b4$var$sb = (0, $2sqaL.createClient)($95a21c9e1364b2b4$var$SB_URL, $95a21c9e1364b2b4$var$SB_KEY);
// =============================================================================
// PAGE TRANSITION
// =============================================================================
document.addEventListener("DOMContentLoaded", ()=>{
    document.body.classList.add("page-entering");
});
document.querySelectorAll("a[href]").forEach((link)=>{
    const href = link.getAttribute("href");
    if (!href || href.startsWith("#") || href.startsWith("http") || href.startsWith("mailto") || link.target === "_blank") return;
    link.addEventListener("click", (e)=>{
        e.preventDefault();
        document.body.classList.add("page-leaving");
        setTimeout(()=>{
            window.location.href = href;
        }, 300);
    });
});
// =============================================================================
// MOBILE MENU
// =============================================================================
function $95a21c9e1364b2b4$var$initMobileMenu() {
    const btn = document.getElementById("hamburgerBtn");
    const menu = document.getElementById("mobileNav");
    const overlay = document.getElementById("menuOverlay");
    const closeBtn = document.getElementById("menuClose");
    if (!btn || !menu) return;
    const open = ()=>{
        menu.classList.add("is-open");
        btn.classList.add("is-open");
        btn.setAttribute("aria-expanded", "true");
        document.body.style.overflow = "hidden";
    };
    const close = ()=>{
        menu.classList.remove("is-open");
        btn.classList.remove("is-open");
        btn.setAttribute("aria-expanded", "false");
        document.body.style.overflow = "";
    };
    requestAnimationFrame(()=>menu.classList.add("is-ready"));
    btn.addEventListener("click", open);
    closeBtn?.addEventListener("click", close);
    overlay?.addEventListener("click", close);
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape") close();
    });
}
$95a21c9e1364b2b4$var$initMobileMenu();
// =============================================================================
// SCROLL TO TOP
// =============================================================================
const $95a21c9e1364b2b4$var$scrollBtn = document.getElementById("scrollToTop");
if ($95a21c9e1364b2b4$var$scrollBtn) {
    window.addEventListener("scroll", ()=>{
        $95a21c9e1364b2b4$var$scrollBtn.classList.toggle("is-visible", window.scrollY > 300);
    });
    $95a21c9e1364b2b4$var$scrollBtn.addEventListener("click", ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
}
// =============================================================================
// STATE
// =============================================================================
let $95a21c9e1364b2b4$var$allReviews = [];
let $95a21c9e1364b2b4$var$activeLetter = "*";
let $95a21c9e1364b2b4$var$activeCategory = "all";
let $95a21c9e1364b2b4$var$searchQuery = "";
// =============================================================================
// FETCH
// =============================================================================
async function $95a21c9e1364b2b4$var$loadReviews() {
    const listEl = document.getElementById("reviewsList");
    const loadingEl = document.getElementById("reviewsLoading");
    const emptyEl = document.getElementById("reviewsEmpty");
    const { data: data, error: error } = await $95a21c9e1364b2b4$var$sb.from("reviews").select("id, title, summary, score, created_at, category, cover_url, banner_url").order("created_at", {
        ascending: false
    });
    loadingEl.hidden = true;
    if (error || !data) {
        emptyEl.hidden = false;
        emptyEl.querySelector("p").textContent = "Erro ao carregar reviews.";
        return;
    }
    $95a21c9e1364b2b4$var$allReviews = data;
    $95a21c9e1364b2b4$var$buildAlphaFilter();
    $95a21c9e1364b2b4$var$render();
}
// =============================================================================
// ALPHA FILTER
// =============================================================================
function $95a21c9e1364b2b4$var$buildAlphaFilter() {
    const letters = [
        ...new Set($95a21c9e1364b2b4$var$allReviews.map((r)=>r.title?.[0]?.toUpperCase()).filter(Boolean))
    ].sort();
    const container = document.getElementById("alphaFilter");
    letters.forEach((letter)=>{
        const btn = document.createElement("button");
        btn.className = "reviews-listing__alpha-btn";
        btn.dataset.letter = letter;
        btn.textContent = letter;
        btn.setAttribute("aria-label", `Filtrar pela letra ${letter}`);
        container.appendChild(btn);
    });
    container.addEventListener("click", (e)=>{
        const btn = e.target.closest(".reviews-listing__alpha-btn");
        if (!btn) return;
        $95a21c9e1364b2b4$var$activeLetter = btn.dataset.letter;
        container.querySelectorAll(".reviews-listing__alpha-btn").forEach((b)=>b.classList.remove("is-active"));
        btn.classList.add("is-active");
        $95a21c9e1364b2b4$var$render();
    });
}
// =============================================================================
// TABS
// =============================================================================
document.querySelectorAll(".reviews-listing__tab").forEach((tab)=>{
    tab.addEventListener("click", ()=>{
        $95a21c9e1364b2b4$var$activeCategory = tab.dataset.cat;
        document.querySelectorAll(".reviews-listing__tab").forEach((t)=>{
            t.classList.remove("is-active");
            t.setAttribute("aria-selected", "false");
        });
        tab.classList.add("is-active");
        tab.setAttribute("aria-selected", "true");
        $95a21c9e1364b2b4$var$render();
    });
});
// =============================================================================
// SEARCH
// =============================================================================
document.getElementById("searchInput").addEventListener("input", (e)=>{
    $95a21c9e1364b2b4$var$searchQuery = e.target.value.trim().toLowerCase();
    $95a21c9e1364b2b4$var$render();
});
// =============================================================================
// RENDER
// =============================================================================
function $95a21c9e1364b2b4$var$render() {
    const listEl = document.getElementById("reviewsList");
    const emptyEl = document.getElementById("reviewsEmpty");
    let filtered = $95a21c9e1364b2b4$var$allReviews;
    if ($95a21c9e1364b2b4$var$activeCategory !== "all") filtered = filtered.filter((r)=>$95a21c9e1364b2b4$var$activeCategory === "anime" ? r.category === "anime" : r.category !== "anime");
    if ($95a21c9e1364b2b4$var$activeLetter !== "*") filtered = filtered.filter((r)=>r.title?.[0]?.toUpperCase() === $95a21c9e1364b2b4$var$activeLetter);
    if ($95a21c9e1364b2b4$var$searchQuery) filtered = filtered.filter((r)=>r.title?.toLowerCase().includes($95a21c9e1364b2b4$var$searchQuery));
    emptyEl.hidden = filtered.length > 0;
    listEl.innerHTML = filtered.map((r)=>$95a21c9e1364b2b4$var$buildCard(r)).join("");
    listEl.querySelectorAll("a[data-review-id]").forEach((link)=>{
        link.addEventListener("click", (e)=>{
            e.preventDefault();
            document.body.classList.add("page-leaving");
            setTimeout(()=>{
                window.location.href = `review.html?id=${link.dataset.reviewId}`;
            }, 300);
        });
    });
}
// =============================================================================
// CARD TEMPLATE
// =============================================================================
function $95a21c9e1364b2b4$var$buildCard(r) {
    const img = r.cover_url || r.banner_url || "";
    const date = r.created_at ? new Date(r.created_at).toLocaleDateString("pt-BR", {
        year: "numeric",
        month: "short"
    }) : "";
    const categoryLabel = r.category === "anime" ? "Anime & Mang\xe1" : "Jogo";
    const score = r.score != null ? Number(r.score).toFixed(1) : null;
    const comment = r.summary ? r.summary.length > 120 ? r.summary.slice(0, 120) + "\u2026" : r.summary : "";
    return `
    <li class="reviews-listing__card">
      <a href="review.html?id=${r.id}" data-review-id="${r.id}" class="reviews-listing__card-link">
        <div class="reviews-listing__card-cover">
          ${img ? `<img src="${img}" alt="${r.title || ""}" loading="lazy" />` : '<div class="reviews-listing__card-cover--placeholder"></div>'}
        </div>
        <div class="reviews-listing__card-body">
          <div class="reviews-listing__card-meta">
            <span class="reviews-listing__card-category">${categoryLabel}</span>
            ${date ? `<span class="reviews-listing__card-date">${date}</span>` : ""}
          </div>
          <h2 class="reviews-listing__card-title">${r.title || "\u2014"}</h2>
          ${comment ? `<p class="reviews-listing__card-comment">${comment}</p>` : ""}
          ${score != null ? `<p class="reviews-listing__card-score" aria-label="Nota ${score}"><span>${score}</span></p>` : ""}
        </div>
      </a>
    </li>
  `;
}
$95a21c9e1364b2b4$var$loadReviews();


//# sourceMappingURL=reviews-list.0c186d98.js.map
